import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { useAppDispatch } from 'hooks/reduxHooks'

import HttpStatus from 'components/Common/HttpStatus'
import Error404PageWithOffers from 'components/Pages/Error404PageWithOffers/Error404PageWithOffers'
import LoadingPage from 'components/Common/Loading/LoadingIndicator'
import ErrorPage from 'components/Pages/ErrorPage'
import { shouldShowMagazineArticle } from 'selectors/contentSelectors'
import { selectLoggedIn } from 'selectors/accountSelectors'
import ContentBlock from 'components/Content/ContentBlock'
import Pane from 'components/Common/Pane'

import {
  fetchHubPage,
} from 'actions/ContentActions'

import { RouteComponentProps, withRouter } from 'react-router'
import { getContentPageKey } from 'lib/url/contentUtils'
import { TYPE_OF_PAGE_CONTENT_HUB } from 'constants/landingPage'
import ErrorBoundary from 'components/Common/ErrorBoundary'

interface Props extends RouteComponentProps<{ slug: string }> {
  hubPage: App.ContentHubPage;
  error?: any;
  magazineArticles: App.ContentMagazineArticlesState;
  shouldShowMagazineArticle: boolean;
  regionCode: string;
  loggedIn: boolean;
}

function HubPage(props: Props) {
  const { hubPage, error, regionCode, loggedIn } = props
  const [previousContent, setPreviousContent] = useState<App.ContentHubPage>()
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(fetchHubPage(props.match.params.slug))
  }, [dispatch, props.match.params.slug])

  useEffect(() => () => {
    if (hubPage) {
      setPreviousContent(hubPage)
    }
  }, [hubPage])

  if (error) {
    if (error.status == 404) {
      return <HttpStatus code={404}>
        <Error404PageWithOffers />
      </HttpStatus>
    }
    return <ErrorPage error={error} />
  }

  if (!hubPage) {
    return <LoadingPage />
  }

  return (
    <Pane type={hubPage.backgroundColour === 'white' ? undefined : 'clear'} key={props.match.params.slug}>
      {hubPage.sections.map((section, i) => (
        // @TODO: this desperately needs a refactor
        // but I want to make this move with minimum risk
        <ErrorBoundary key={i} fallback={null}>
          <ContentBlock
          key={section.hash}
          hubPage={hubPage}
          sections={hubPage.sections}
          section={section}
          i={i}
          previousContent={previousContent}
          isLoggedIn={loggedIn}
          regionCode={regionCode}
          magazineArticles={props.magazineArticles}
          shouldShowMagazineArticle={props.shouldShowMagazineArticle}
          match={props.match}
          />
        </ErrorBoundary>
      ))}
    </Pane>
  )
}

function mapStateToProps(state: App.State, ownProps: Partial<Props>) {
  const key = getContentPageKey(ownProps.match.params.slug, TYPE_OF_PAGE_CONTENT_HUB)

  return {
    hubPage: state.content.landingPages[key],
    error: state.content.landingPageErrors[key],
    magazineArticles: state.content.magazineArticles,
    shouldShowMagazineArticle: shouldShowMagazineArticle(state),
    regionCode: state.geo.currentRegionCode,
    loggedIn: selectLoggedIn(state),
  }
}

export default connect(mapStateToProps)(withRouter(HubPage))
